// frontend/src/components/InvestmentPlansList.tsx

import React from 'react';
import { Table, Button } from 'antd';
import type { InvestmentPlan } from '../types';

interface Props {
  plans: InvestmentPlan[];
  onOrder(plan: InvestmentPlan): void;
  expandableDetails?: Record<string, InvestmentPlan[]>;
  onNextPage?(): void;
}

const InvestmentPlansList: React.FC<Props> = ({
  plans,
  onOrder,
  expandableDetails,
  onNextPage,
}) => {
  const columns = [
    { title: '币种', dataIndex: 'symbol', key: 'symbol' },
    { title: '期限', dataIndex: 'timeframe', key: 'timeframe' },
    { title: '投入(USDT)', dataIndex: 'amountUSDT', key: 'amountUSDT' },
    { title: '止盈', dataIndex: 'takeProfitPrice', key: 'takeProfitPrice' },
    { title: '止损', dataIndex: 'stopLossPrice', key: 'stopLossPrice' },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: InvestmentPlan) => (
        <Button type="link" onClick={() => onOrder(record)}>
          下单
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={plans}
        rowKey={r => r.symbol + r.timeframe}
        pagination={false}
        expandable={
          expandableDetails
            ? {
                // remove expandIconColumnIndex to eliminate warning
                expandedRowRender: record => {
                  const details = expandableDetails[record.symbol] || [];
                  return (
                    <Table
                      columns={columns}
                      dataSource={details}
                      rowKey={r => r.symbol + r.timeframe}
                      pagination={false}
                      size="small"
                    />
                  );
                },
              }
            : undefined
        }
      />
      {onNextPage && (
        <div style={{ textAlign: 'right', marginTop: 8 }}>
          <Button onClick={onNextPage}>下一页</Button>
        </div>
      )}
    </>
  );
};

export default InvestmentPlansList;
